
  const lien1pc = "https://motion19.com/cdn/shop/files/v-banner_pc1.jpg";
  const lien1mob = "https://motion19.com/cdn/shop/files/v-banner_mobile_1.jpg";

  
  const lien2pc = "https://motion19.com/cdn/shop/files/v-banner_mobile_21.jpg";
  const lien2mob = "https://motion19.com/cdn/shop/files/v-banner_mobile_2.jpg";

  
  const lien3pc = "https://motion19.com/cdn/shop/files/v-banner_mobile_31.jpg";
  const lien3mob = "https://motion19.com/cdn/shop/files/v-banner_mobile_3.jpg";



  var mod1 = "#section-template--16090893582513__1650006839d9b4e95c"
  var mod2 = "#section-template--16090893582513__16500077567e8789a4"
  var mod3 = "#section-template--16090893582513__165000819169f58a2b"


  var id1 = mod1+"  .block-image-inner a";
  var id2 = mod2+"  .block-image-inner a";
  var id3 = mod3+"  .block-image-inner a";


console.log(id1);

  var link1 =null;
  var link2 =null;
  var link3 =null;
  
  const mediaQuery = window.matchMedia('(max-width: 768px)')

  
  // Check if the media query is true
  if (mediaQuery.matches) {
    link1 = lien1mob;
    link2 = lien2mob;
    link3 = lien3mob;
  }else{
    
    link1 = lien1pc;
    link2 = lien2pc;
    link3 = lien3pc;
  }


  let elements1 = document.querySelectorAll(id1);

  for (let elem1 of elements1) {
    var span = document.createElement("span");

    var image1 = document.createElement("img");
    image1.src = link1;
    elem1.appendChild(span);
    span.appendChild(image1);
  }


  let elements2 = document.querySelectorAll(id2);

  for (let elem2 of elements2) {
    var span = document.createElement("span");

    var image2 = document.createElement("img");
    image2.src = link2;
    elem2.appendChild(span);
    span.appendChild(image2);
  }


  let elements3 = document.querySelectorAll(id3);

  for (let elem3 of elements3) {
    var span = document.createElement("span");

    var image3 = document.createElement("img");
    image3.src = link3;
    elem3.appendChild(span);
    span.appendChild(image3);
  }

